export default __webpack_public_path__ + "9bda0cfc5393b75a1408b3fdf5dc228b.png";